import { Async as ReactSelect } from 'react-select';

import { map } from 'ramda';
import PropTypes from 'prop-types';

const deprecatedTypes = ['cm:authority', 'cm:person', 'cm:authorityContainer'];

export default class Authority extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    excludedOptions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ),
    isClearable: PropTypes.bool,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    parentAuthority: PropTypes.string,
    styles: PropTypes.object,
    type: PropTypes.oneOf(['cm:authority', 'cm:person', 'cm:authorityContainer', 'USER', 'GROUP']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    excludedOptions: [],
    multi: false,
    styles: {},
  };

  constructor(props) {
    super(props);

    this.getOptions = ::this.getOptions;
    this.filterOptions = ::this.filterOptions;
  }

  componentDidMount() {
    const { type } = this.props;
    if (deprecatedTypes.includes(type)) {
      console.warn(`Using legacy auhtority type ( ${type} ), valid type names are USER or GROUP`);
    }
  }

  getOptions(input) {
    let { type, parentAuthority } = this.props;
    if (type === 'cm:person' || type === 'USER') type = 'USER';
    else if (type === 'cm:authorityContainer' || type === 'GROUP') type = 'GROUP';
    else type = null;

    return fetch(
      `${window.appContext}/proxy/alfresco/edocat/findAuthorities?limit=20${
        input ? `&displayNamePattern=*${input}*` : ''
      }${type ? `&type=${type}` : ''}${parentAuthority ? `&parentAuthority=${parentAuthority}` : ''}`,
      {
        credentials: 'same-origin',
      }
    )
      .then(response => response.json())
      .then(response => {
        return map(
          item => ({
            ...item,
            label: item.display,
            value: item.nodeRef,
          }),
          response
        );
      });
  }

  filterOptions(item) {
    const { allowSystem, excludedOptions } = this.props;

    let isValid = true;

    if (window.Alfresco.constants.USERNAME !== 'onlio-admin') {
      isValid =
        item.label &&
        item.label !== 'onlio_sudo_allowed' &&
        item.label !== 'onlio_sudo_disallowed' &&
        item.label !== 'onlio_power_user' &&
        item.label !== 'onlio_model_manager';
    }

    if (!isValid) {
      return false;
    }

    isValid =
      item.label &&
      !item.label.startsWith('ALFRESCO') &&
      !item.label.startsWith('SITE') &&
      !item.label.startsWith('EMAIL') &&
      !item.label.includes('Guest');

    if (!isValid) {
      return false;
    }

    if (!allowSystem) {
      isValid =
        item.label &&
        !item.label.startsWith('onlio_') &&
        item.label !== 'DATABOX_OPERATOR' &&
        !item.label.toLowerCase().includes('admin');
    }

    if (excludedOptions.length > 0) {
      isValid = !excludedOptions.some(option => option.value === item.value);
    }

    return isValid;
  }

  render() {
    const {
      allowSystem,
      autoFocus,
      className,
      disabled,
      isClearable,
      multi,
      name,
      onBlur,
      onChange,
      readOnly,
      styles,
      title,
      value,
    } = this.props;

    return (
      <ReactSelect
        autoFocus={autoFocus}
        className={className}
        classNamePrefix="Edocat-Select"
        defaultOptions
        filterOption={this.filterOptions}
        id={name}
        isClearable={isClearable}
        isDisabled={disabled}
        isMulti={multi}
        loadingMessage={() => window.Alfresco.messages.global['label.loading']}
        loadOptions={this.getOptions}
        name={name}
        noOptionsMessage={() => window.Alfresco.messages.global['edocat.text.no-results']}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={`${window.Alfresco.messages.global['button.select']}...`}
        readOnly={readOnly}
        searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
        title={title}
        value={
          Array.isArray(value)
            ? value.filter(item => {
                if (allowSystem) return item;

                return (
                  item.label &&
                  !item.label.startsWith('onlio_') &&
                  item.label !== 'DATABOX_OPERATOR' &&
                  !item.label.toLowerCase().includes('admin')
                );
              })
            : value
        }
        styles={{
          ...styles,
          multiValue: (base, { data }) => ({
            ...base,
            background: data.type === 'cm:person' || data.type === 'USER' ? '#a2daff' : '#ffd07b',
          }),
        }}
      />
    );
  }
}
